import { Link } from '@chakra-ui/react'

export const faqs = [
  {
    question: 'Is LYKSTAGE free to use?',
    answer:
      "Yes. Creating an account, watching, and starting a channel are free. The free creator tier includes 10 GB of storage and earnings from ads. Plus and Pro add more storage, password protection and pay-per-view.",
  },
  {
    question: 'How do I join LYKSTAGE?',
    answer:
      "Head over to www.lykstage.com, click 'Discover LYKSTAGE' or 'Skip' on the Home feed, then sign up as an Individual or a Business.",
  },
  {
    question: 'How do I sign out?',
    answer: "Click the 'Sign Out' button in the left menu bar.",
  },
  {
    question: 'How do I upload videos?',
    answer:
      "After logging in, click on the 'Upload Video' button next to the notification button and follow the on-screen instructions.",
  },
  {
    question: 'Is there a limit on video length or quality?',
    answer:
      "There is no short-clip ceiling. Upload full-length videos at full quality within your storage allowance.",
  },
  {
    question: 'How do I start my channel?',
    answer:
      "Once you upload your first video, 'My Creation' appears on the left menu with your profile name as your channel name.",
  },
  {
    question: 'How do I remove a video?',
    answer:
      "Go to 'My Creations' on the left, find the video under 'Uploaded Video,' then hit 'Delete.'",
  },
  {
    question: 'Wanna set up an event?',
    answer:
      "Click 'Create' on the left menu, pick 'Event,' and follow the cues.",
  },
  {
    question: "Want notifications? Here's how!",
    answer:
      "Click the bell icon on the home feed, then tap 'Settings' to customize your notification preferences.",
  },
  {
    question: 'Need a notification break?',
    answer:
      "Tap the Bell icon, select 'Settings,' then slide the bars to turn off any alerts.",
  },
  {
    question: 'Saving videos for later?',
    answer:
      "Click the three dots below a video's card and hit 'Watchlist' to save it for later.",
  },
  {
    question: "Need to report a video? Here's how:",
    answer: "Click on the three dots below the video and hit 'Report video.'",
  },
  {
    question: "What happens when I report a video, channel or comment?",
    answer: "The reported item is removed from your feed and recommendations immediately, and our monitoring team reviews the report within 48 hours. You will be told the outcome.",
  },
  {
    question: "Can I control comments on my videos?",
    answer: "Yes. From Comment Controls you can turn comments off, hold them for review, pin, hide and block.",
  },
  {
    question: 'How will I Like, Share, and Comment on a Video?',
    answer:
      "On the video details page, you'll see these options below every video. Tap the share icon to share the video or click 'Copy Link'.",
  },
  {
    question: 'Curious about our rules and policies?',
    answer:
      'Check the bottom of the left-side menu for our terms, conditions, and policies.',
  },
  {
    question: 'How to change or add your DP (Display Picture)?',
    answer:
      'Go to your profile on the left menu, click the camera icon on your current pic, and change or add a new one.',
  },
  {
    question: 'Want to update your password?',
    answer: "Click on your profile, then select 'Change Password'.",
  },
  {
    question: 'How to update your profile details?',
    answer: 'Go to your profile, then edit and update your info.',
  },
  {
    question: 'What should I do if I have a duplicate profile?',
    answer:
      'If you believe you have a duplicate profile, please report it by emailing us at ip@lykstage.com. To investigate, you must first have an active account on LYKSTAGE with videos uploaded from your verified account. Include details about the situation, especially if you suspect that someone has created a duplicate profile without your knowledge.',
  },
  {
    question: 'How can I retrieve my account?',
    answer:
      'To retrieve your account, follow the password reset procedure found on the login page. If you continue to experience difficulties, please contact our support team at support@lykstage.com for assistance.',
  },
  {
    question: 'How do I edit my channel name?',
    answer:
      'To edit your channel name, go to "My Channel" and click on the "Edit Channel" button. In your channel settings, select the option to change your channel name and make the desired updates.',
  },
  {
    question: 'What’s the difference between channel name and full name?',
    answer:
      'Your channel name is the public name displayed to viewers on the platform, while your full name refers to your personal name used for identification purposes within LYKSTAGE.',
  },
  {
    question: 'How to retrieve your account on deactivation?',
    answer:
      'Simply re-login using your existing email or phone number and password.',
  },
  {
    question:
      'What happens if you are having second thoughts after deleting your account?',
    answer:
      'After 15 days, you can sign up again using the same details, but your old data will be gone.',
  },
  {
    question: 'How can I cash out my LYKSTAGE earnings?',
    answer: (
      <p>
        Here's how to cash out your LYKSTAGE earnings:
        <ol className="list-decimal pl-4">
          <li>
            <b>Verify your Account:</b> Before you can redeem your LYK Coins,
            you'll need to go through a verification process on the platform.
            This typically involves providing a valid ID and linking a bank
            account.
          </li>
          <li>
            <b>Check Your Balance:</b> Head over to the{' '}
            <Link href="/earnings" color={'blue'}>
              "Earnings"
            </Link>{' '}
            section of your LYKSTAGE account. This will show you how many LYK
            Coins you've accumulated.
          </li>
          <li>
            <b>Meet the Payout Threshold:</b>You can only redeem your LYK Coins
            once you reach the minimum amount required for a payout. This
            threshold varies depending on your location:{' '}
            <ul className="list-disc pl-4">
              <li>
                For the US and other countries excluding India: 1300 LYK Coins
                ($26)
              </li>
              <li>For India: 130 LYK Coins ($2.6)</li>
            </ul>
          </li>
          <li>
            <b>Redeem Your Coins:</b> If you have enough LYK Coins, simply click
            the "Redeem Now" button within the{' '}
            <Link href="/earnings" color={'blue'}>
              "Earnings"
            </Link>{' '}
            section. The redeemed amount will be transferred directly to your
            linked bank account.
          </li>
        </ol>
      </p>
    ),
  },
  {
    question: 'Do I need a big following before I can earn?',
    answer:
      "No. There is no subscriber or watch-hour threshold. Your videos earn from monetized watch time from the first upload. If you already have a strong record on another platform, you can request a complimentary upgrade to a paid tier from the Upload screen.",
  },
  {
    question: 'Do viewers earn too?',
    answer:
      "Yes. Logged-in viewers are rewarded on the same monetized watch time. Viewing while logged out does not earn viewer rewards, although it still counts toward the creator's earnings.",
  },
  {
    question: 'How do earnings work on LYKSTAGE?',
    answer: (
      <div>
        On LYKSTAGE, earnings for both creators and viewers are based on watch
        time consumption:
        <p>
          <b>Creators:</b> On LYKSTAGE, Creators earn based on ad earnings
          generated by the content traction when ads are served.
        </p>
        <p>
          <b>Viewers:</b> Every 30-second interval watched while logged in
          counts as one Watch Time Unit, which converts directly into LYK Coins.
        </p>
        <p>
          These coins are then redeemed for cash, with values adjusted based on
          local economic conditions.
        </p>
        <p>
          Both creators and viewers benefit from LYKSTAGE's Revenue Share
          Program, creating a mutually beneficial ecosystem where interactions
          and contributions are rewarded.
        </p>
      </div>
    ),
  },
  {
    question: 'What are LYK Coins worth?',
    answer:
      "50 LYK Coins = US$1. Your wallet shows both the coin balance and the US dollar equivalent.",
  },
  {
    question: 'When do my earnings update?',
    answer:(
    <div>
        Your dashboard earnings update within 24 hours of your activity, whether you earn as a creator or as a viewer. This is different from settlement. Earnings accumulate through each monthly billing cycle, which runs from the 22nd of one month to the 21st of the next, and the final balance for that cycle is settled on the 7th of the following month.
        <p>
          <b>Example:</b> activity between August 22nd and September 21st settles on October 7th.
        </p>
        <p>
          Your dashboard always shows your up to date earnings. The settlement date is only when the cycle’s balance is finalised for payout. If you join mid cycle, your first settlement follows the cycle you joined in.
        </p>
      </div>
    )
  },
  {
    question: 'Why do my earnings show as estimates?',
    answer:
      "The wallet statement closes on the 21st of every month; one cycle runs from the 22nd of the previous month to the 21st of the current month. Figures for the open cycle are estimates until the statement closes.",
  },
  {
    question:
      'How do creators earn on LYKSTAGE?',
    answer:
      "Through monetized watch time. When a viewer watches your video uninterrupted and watches the ad in full, that watch time is monetized and you earn LYK Coins. Ads are skippable, so a full ad view signals genuine engagement. LYKSTAGE's Watch-Time model is patented.",
  },
  {
    question:
      'Why is my video not earning creator revenue?',
    answer:
      "Only videos longer than 3 minutes (180 seconds) are eligible for creator earnings from ad views. Videos shorter than 3 minutes can still be watched and can still generate viewer rewards for your audience, but they do not generate creator earnings for you. To earn as a creator, upload videos longer than 3 minutes.",
  },
  {
    question:
      'What is the difference between viewer earnings and creator earnings?',
    answer:
      "You can earn in two ways on LYKSTAGE. As a viewer, you share in monetized watch time when you watch content uninterrupted and watch the accompanying advertisement completely without skipping. As a creator, you earn from monetized views of your own eligible videos, which are videos longer than 3 minutes. Your dashboard shows both.",
  },
  {
    question: 'Why does my earning show as zero sometimes?',
    answer: (
      <div>
        Earnings smaller than four decimal places are rounded to “0.0000” for
        display. This doesn’t mean your earnings are zero—it just hasn’t reached
        the display threshold yet.
        <p>
          <b>Example:</b> If your earning is 0.000034, it will show as 0.0000.
          Once it reaches 0.0001 or more, it will display correctly. All
          earnings are tracked and updated as they accumulate.
        </p>
      </div>
    ),
  },
  {
    question:
      'What is the minimum video length requirement to be eligible for monetization?',
    answer:
      "For Individual and business creators, it's 3 minutes, equivalent to 6 watch-time units except for media and broadcasting creators classified as business users, monetization begins for videos as short as 30 seconds.",
  },
  {
    question:
      'How can you achieve better rewards on LYKSTAGE with a smaller audience base?',
    answer:
      "Even with a smaller audience, if they're engaged, you'll accumulate more Watch Time Units, leading to better rewards.",
  },
  {
    question: 'How is LYKSTAGE switching up the watch and earn game?',
    answer:
      "LYKSTAGE focuses on 'Watch Time' instead of 'Views', rewarding creators for every moment of engagement.",
  },
  {
    question: 'When and how should I verify my account details?',
    answer:
      'You should verify your account details before redeeming any earnings. To do this, simply click the verification button located on your profile. Ensure your account is verified once you have a sufficient balance for redemption.',
  },
  {
    question:
      'What should I do if I encounter an issue with account verification?',
    answer:
      'If you encounter an issue with account verification, ensure that all your details are correct. Keep in mind that you must reach the required number of LYK Coins before initiating the verification process. After correcting any discrepancies, you can retry, as you have three attempts. If you still face issues after using all attempts, please email us at support@lykstage.com for further assistance.',
  },
  {
    question: 'Why are my account details showing incorrectly?',
    answer:
      'Incorrect display of account details may be due to data entry errors. Verify the information you entered and re-enter it if necessary. For further assistance, please email us at support@lykstage.com.',
  },
  {
    question: 'Why are coins being deducted for verification?',
    answer:
      'Coins are deducted for verification to cover the necessary processing fees involved in ensuring the authenticity and security of your account.',
  },
  {
    question: 'Can I add a beneficiary?',
    answer: "No, you can't add a beneficiary as of now.",
  },
  {
    question: 'What should I do if I cannot log in to my account?',
    answer:
      "If you're having trouble logging in, first ensure you're entering the correct credentials. If you signed up using your email, Google, or Apple account, make sure you're using the same method. If you’ve forgotten your password, use the “Forgot Password” option. If the issue persists, please email us at support@lykstage.com.",
  },
  {
    question:
      'What should I do if my email address is showing as not registered?',
    answer:
      'If your email address is showing as not registered, it’s possible that you logged in using a different method or email address. Please ensure you log in with the same credentials and method you used during sign-up.',
  },
  {
    question: 'How can you redeem your reward balance?',
    answer: (
      <p>
        To redeem your reward balance on LYKSTAGE:
        <ol className="list-decimal pl-6">
          <li>
            <b>Accumulate LYK Coins:</b> Earn LYK Coins through ad revenue
            generated when your content's watch time is monetized.
          </li>
          <li>
            <b>Reach Payout Threshold:</b>{' '}
            <ul className="list-disc pl-4">
              <li>
                For the US and other countries excluding India: 1300 LYK Coins
                ($26)
              </li>
              <li>For India: 130 LYK Coins ($2.6)</li>
            </ul>
          </li>
          <li>
            <b>Verify Your Account:</b> Complete the verification process by
            providing a valid ID and bank account details.
          </li>
          <li>
            <b>Redeem Your Coins:</b>Once verified, you can redeem your LYK
            Coins, and the equivalent cash amount will be credited to your bank
            account.
          </li>
        </ol>
      </p>
    ),
  },
  {
    question: 'What are the withdrawal options?',
    answer:
      'Withdrawal options typically include bank transfers, where funds can be transferred directly to your bank account. Ensure your account is verified for a smooth transaction process.',
  },
  {
    question: 'How can I check my earnings?',
    answer:
      'You can check your earnings by navigating to the “Earnings” page in your account.',
  },
  {
    question: 'How much can I earn by watching for 1 hour?',
    answer:
      'The amount you can earn from watching a video for one hour varies depending on the nature and frequency of the ads served during that time. Since the ads associated with each video can differ, there is no fixed earning amount based solely on time spent watching.',
  },
  {
    question: 'What’s the difference between estimated and redeemable balance?',
    answer:
      'The estimated balance refers to the total amount earned that is not yet available for withdrawal, as it is subject to review and confirmation. After this review, the amount becomes the redeemable balance, which is the amount you can cash out once everything is approved.',
  },
  {
    question:
      "Why aren't my earnings updating despite views, likes, subscriber counts, and watch time?",
    answer: (
      <p>
        If your earnings aren't getting updated on LYKSTAGE, even though your
        videos are getting views, likes, and watch time, several factors could
        be affecting the results:
        <ol className="list-decimal pl-6">
          <li>
            <b>Watch Time from Non-Monetized Regions:</b> If a significant
            portion of your watch time comes from countries where monetization
            isn’t available, earnings may not accumulate. LYKSTAGE only
            generates revenue from views in regions where monetization is
            supported.
          </li>{' '}
          <li>
            <b>Limited Ad Serving:</b> Ads may not display on all videos due to
            ad safety protocols or if the content doesn’t align with advertiser
            criteria. Limited or absent ads reduce the revenue potential from
            those views.
          </li>{' '}
          <li>
            <b>Viewer Behavior (Content Skipping):</b> If viewers frequently
            skip portions of the video, it can impact earnings. Only
            uninterrupted watch time qualifies for monetization, so frequent
            skips may lead to lower earnings.
          </li>
          <li>
            <b>Ad Blocker Usage:</b> If viewers use ad blockers, ads may not
            display, meaning their watch time won’t contribute to ad-based
            revenue.
          </li>
        </ol>
        If you have further concerns about your earnings or specific videos,
        please check out other FAQs or email us at{' '}
        <a
          href="mailto:support@lykstage.com"
          className="text-blue-600 underline"
        >
          support@lykstage.com
        </a>
        .
      </p>
    ),
  },
  {
    question: 'I have watched a lot, but why haven’t I received any coins?',
    answer: (
      <p>
        To earn and receive coins as a viewer, please check the following
        criteria:
        <ol className="list-decimal pl-6">
          <li>
            <b>Login Status:</b> Ensure you are logged in to your account while
            watching videos.
          </li>{' '}
          <li>
            <b>Ad Availability:</b> Confirm that ads are being served on the
            video. Coins are only earned on monetized videos with ads.
          </li>{' '}
          <li>
            <b>Video Length:</b> The video must be at least 3 minutes long to
            qualify for earning coins.
          </li>
          <li>
            <b>Watch Time:</b> You earn coins for every uninterrupted 30-second
            interval of watch time on monetized videos.
          </li>
        </ol>
        Make sure to meet all these conditions to receive your coins!
      </p>
    ),
  },
  {
    question: 'What if I loop a video on repeat?',
    answer:
      "Looping a video on repeat on LYKSTAGE doesn't contribute to increased earnings for creators. The platform's algorithms are designed to detect such behaviors and ensure that genuine viewer engagement is rewarded. Earnings are based on unique watch time and viewer interactions, not on repetitive views from the same user.",
  },
  {
    question: 'What if I skip through videos?',
    answer:
      'To earn rewards, you need to watch for a straight 30 seconds without skipping.',
  },
  {
    question: 'How much time should I spend on a video to earn?',
    answer:
      'Watch a video for at least 30 seconds without skipping to start earning.',
  },
  {
    question: "How long can I watch a 'Premium Video' after I buy it?",
    answer:
      "You have 30 days to watch it, and once you start, you've got 48 hours to finish.",
  },
  {
    question: "Can I set my own password for a 'Password-Protected Video'?",
    answer: 'The password is system-generated, but you can reset it.',
  },
  {
    question: 'Do creators earn rewards for watching videos?',
    answer:
      'Yes, creators earn rewards for watching videos, except on business accounts.',
  },
  {
    question: "What's 'Premium Play' on LYKSTAGE?",
    answer:
      "'Premium Play' offers exclusive content for rent, available for a limited time.",
  },
  {
    question: 'How are creators rewarded on LYKSTAGE?',
    answer: 'Creators are rewarded based on unique watch time viewed.',
  },
  {
    question: 'What types of videos are allowed on this platform?',
    answer:
      'Various categories of content are allowed, including Animation, Automobile, Comedy, Documentary, Education, Entertainment, Food, and more.',
  },
  {
    question: 'Are there any restrictions on who can become a creator?',
    answer:
      'Creators must be at least 13 years old and provide original content.',
  },
  {
    question: 'How are Inappropriate videos handled on this platform?',
    answer:
      'Inappropriate content is removed based on community guidelines, and users can report such content.',
  },
  {
    question: 'What is the maximum amount I can Redeem?',
    answer: 'There is no maximum limit to the redeemable amount.',
  },
  {
    question: 'What is the minimum amount I can Redeem?',
    answer: (
      <p>
        The minimum amount you can redeem on LYKSTAGE depends on your location:
        <ul className="list-disc pl-4">
          <li>
            For the US and other countries excluding India: 1300 LYK Coins ($26)
          </li>
          <li>For India: 130 LYK Coins ($2.6)</li>
        </ul>
      </p>
    ),
  },
  {
    question:
      "How's an Individual account different from the Business one on LYKSTAGE?",
    answer:
      'Individual accounts are for creating and monetizing videos, while Business accounts are for businesses, especially in the Media and Entertainment industry.',
  },
  {
    question:
      "Got a video that's out-of-the-box and doesn't fit our categories?",
    answer: 'Currently, videos must fit the existing categories on LYKSTAGE.',
  },
  {
    question: 'Want to give your channel a new name?',
    answer:
      "Go to the Profile section, click 'Edit,' and change your channel name.",
  },
  {
    question:
      'How is the revenue from Premium Play divided between LYKSTAGE and the Creator?',
    answer:
      "Creators typically receive 75% of the revenue, but the exact split is at LYKSTAGE's discretion.",
  },
  {
    question:
      'What share of ad revenue do creators receive?',
      answer:
      "Between 45% and 70% of a video's recognized ad earnings, tiered by that video's lifetime unique viewers. The tier is evaluated daily and only moves up as the audience grows. Details are on the How earnings work page.",
  },
  {
    question: 'How to hide/unhide personal details?',
    answer:
      "Go to 'Profile,' then choose 'Public' or 'Private' next to your details.",
  },
  {
    question: 'What is Watch Time on LYKSTAGE?',
    answer:
      'Watch time is the duration viewers spend watching content on LYKSTAGE, measured in 30-second units.',
  },
  {
    question: 'Does all watch time earn?',
    answer:
      'No. Only monetized watch time earns: uninterrupted viewing where the ad is watched in full. Monetized watch time is also capped at 6 hours per user in every 24 hours; watching beyond that does not earn.',
  },
  {
    question: 'How is a view counted?',
    answer:
      'A view registers when playback actually starts, once per viewer per video in a 30-minute window. Earnings are based on 30-second units of uninterrupted watching, not on views.',
  },
  {
    question: 'How is View and Watch Time different?',
    answer:
      'Views are registered for at least 30 seconds of watching, while Watch Time measures every 30-second segment of engagement.',
  },
  {
    question:
      'How does LYKSTAGE reward viewers for their time spent on the platform?',
    answer:
      "Viewers earn one 'Watch Time Unit' for every 30 seconds spent watching content.",
  },
  {
    question:
      'Do I need to be a registered user to earn rewards through Watch Time Units on LYKSTAGE?',
    answer:
      'Yes, you need to be a registered user to earn rewards through Watch Time Units.',
  },
  {
    question: 'How can creators start earning on LYKSTAGE?',
    answer:
      'Creators can start earning by registering, setting up their profile, uploading engaging content, and participating in the community.',
  },
  {
    question: "What factors affect a creator's potential earnings on LYKSTAGE?",
    answer:
      'Engaging and popular content leads to higher potential earnings, as it accumulates more watch time units.',
  },
  {
    question: 'How do I create new content on LYKSTAGE?',
    answer:
      "Sign in, click 'Create,' upload your video, add details, and once approved, it will be featured on the feed.",
  },
  {
    question: 'Where can I view my total earnings on LYKSTAGE?',
    answer: "Navigate to the 'Earnings' page to view your earnings.",
  },
  {
    question:
      'How does LYKSTAGE pay creators and viewers before generating revenue?',
    answer:
      'LYKSTAGE estimates potential earnings using a simulation model based on views and watch time, rewarding creators and viewers from the start.',
  },
  {
    question:
      'What is the minimum duration requirement for videos uploaded on the platform?',
    answer: 'Videos must be more than 30 seconds in duration to be uploaded.',
  },
  {
    question:
      'Why are my accumulated earnings different from my redeemable balance?',
    answer:
      'Earnings are adjusted for fake engagement, ensuring only genuine interactions contribute to the redeemable balance.',
  },
  {
    question:
      "How are advance payments managed for Premium Play and Regular free content on a Creator's page?",
    answer:
      "Advance payments are adjusted from the accumulated revenue generated by all content available on the Creator's page.",
  },
  {
    question:
      'I uploaded a video for rent, but I want to delete it. What happens to existing rentals?',
    answer:
      'Existing rentals will continue until their rental period expires, then the video will be permanently removed.',
  },
  {
    question:
      'A user requested to delete a video I rented out. Can I still watch it?',
    answer:
      'You can still watch it until your rental period ends, after which the video will be removed.',
  },
  {
    question: "What happens if my video doesn't get rented by enough people?",
    answer:
      'Videos must achieve a minimum of 5 rentals per month to avoid removal.',
  },
  {
    question: 'How are earnings calculated on LYKSTAGE?',
    answer:
      'Earnings on LYKSTAGE are calculated based on monetized watch time and ad revenue generated by the video content.',
  },
  {
    question:
      'What is the password-protected video feature, and how can you access it?',
    answer:
      'The feature allows creators to secure videos with a password, accessible only to those with the password.',
  },
  {
    question:
      'What should I do if I believe my copyrighted material has been infringed on LYKSTAGE?',
    answer:
      'If you believe your copyrighted material has been infringed, follow the steps outlined in our Copyright Claim procedure. This involves submitting detailed evidence and documentation proving your ownership and the infringement.',
  },
  {
    question: 'What evidence do I need to submit for a copyright claim?',
    answer: (
      <p className="pl-6">
        You need to provide:
        <ul className="list-disc pl-6">
          <li>A clear description of the copyrighted work.</li>
          <li>
            Evidence of ownership (e.g., copyright registration certificate,
            proof of creation date).
          </li>
          <li>
            A specific description of where the alleged infringing material is
            located on LYKSTAGE (e.g., URL, channel name, video title).
          </li>
          <li>
            Your contact information (address, telephone number, email address).
          </li>
          <li>
            A statement of good faith belief that the use is not authorized.
          </li>
          <li>
            A statement that the information is accurate and that you are
            authorized to act on behalf of the copyright owner.
          </li>
          <li>A physical or electronic signature.</li>
        </ul>
      </p>
    ),
  },
  {
    question: 'When can I receive a copyright strike?',
    answer: (
      <p>
        You may receive a copyright strike if you upload content that infringes
        on copyright laws or uses copyrighted material without proper
        permission. Please refer to our{' '}
        <Link href="/privacypolicy" color={'blue'} textDecoration={'underline'}>
          policies
        </Link>{' '}
        and guidelines for specific details.
      </p>
    ),
  },
  {
    question: 'Who can file a copyright claim on LYKSTAGE?',
    answer:
      'The copyright owner or an authorized representative with an active channel on LYKSTAGE can file a copyright claim.',
  },
  {
    question: 'Why should I claim my channel?',
    answer:
      'Like most platforms, LYKSTAGE cannot pre-reserve every creator handle. We promptly remove impersonation on verified reports, but the only guaranteed way to secure your identity is to claim and verify your channel.',
  },
  {
    question: 'What types of content can be subject to copyright claims?',
    answer: (
      <p className="pl-6">
        Content that can be subject to copyright claims includes, but is not
        limited to:
        <ul className="list-disc pl-6">
          <li>Logos</li>
          <li>Audio recordings</li>
          <li>Cover photos</li>
          <li>Other static images</li>
          <li>Video content</li>
        </ul>
      </p>
    ),
  },
  {
    question: 'What happens after I file a copyright claim?',
    answer:
      'Upon receipt of your claim, LYKSTAGE will review the evidence and take appropriate action. If the decision is in your favor, the infringing party will be notified to remove the content and given 14 days to respond.',
  },
  {
    question: 'What if the alleged infringing party disputes the claim?',
    answer:
      'If the alleged infringing party disputes the claim and provides supporting documentation, LYKSTAGE will review the evidence from both parties. If the evidence is inconclusive, the parties may need to resolve the matter independently.',
  },
  {
    question: 'What is a counter-notice, and when can it be filed?',
    answer:
      'A counter-notice can be filed by the alleged infringing party if they believe the content was removed by mistake or misidentification. It must include a written statement of good faith belief, identification of the material, and contact information, along with a physical or electronic signature.',
  },
  {
    question:
      'What should I do if LYKSTAGE determines the evidence is inconclusive?',
    answer:
      'If LYKSTAGE determines the evidence is inconclusive, both parties will be notified to resolve the matter outside of LYKSTAGE. Alternative Dispute Resolution (ADR) options such as mediation or arbitration can be considered.',
  },
  {
    question: 'What happens if I need to file a repeated claim?',
    answer:
      'If you need to file a repeated claim, you must follow the same detailed procedure as the initial claim. Previous claims cannot be relied upon for new claims of infringement.',
  },
  {
    question: 'How do I contact LYKSTAGE for filing a copyright claim?',
    answer:
      'All copyright claims should be sent via email to ip@lykstage.com. Include a description of the copyrighted work, the location of the alleged infringing material, your contact information, and the required statements and signature.',
  },
  {
    question:
      ' How does LYKSTAGE ensure fairness in handling copyright claims?',
    answer:
      'LYKSTAGE ensures a fair and systematic approach to handling copyright claims, protecting the rights of all parties involved. Our policy is designed to be thorough and unbiased, ensuring that every claim is reviewed meticulously.',
  },
  {
    question: 'What should I do if I encounter an error during video upload?',
    answer:
      'If you encounter an error while uploading a video, first check your internet connection and ensure that the video meets the platform’s requirements. In the event of a transcoding error or other issues, you will receive an email with instructions for re-uploading the video.',
  },
  {
    question: 'How do I delete my video?',
    answer:
      'To delete a video, navigate to "My Channel," go to your video library, select the video you want to delete, click on the three dots (⋮) next to the video, and choose the “Delete” option.',
  },
  {
    question: 'How many ways can we upload a video on LYKSTAGE?',
    answer: (
      <p>
        You can upload a video on LYKSTAGE in several ways:
        <ol className="list-decimal pl-6">
          <li>
            <b>Local Drive:</b> Upload videos directly from your computer's
            local storage.
          </li>{' '}
          <li>
            <b>Cloud Storage Platforms:</b> You can also upload videos from
            cloud storage services such as Dropbox and Google Drive.
          </li>{' '}
        </ol>
        Simply navigate to the “Upload” section, select your preferred method,
        fill in the required details, and click on the “Publish” button when
        ready.
      </p>
    ),
  },
  {
    question: 'How do I embed a video?',
    answer:
      'To embed a video, go to the video you want to share, click on the “Share” option, and select the embed code to copy.',
  },
  {
    question: 'My Video Upload is Stuck in Processing. What Should I Do?',
    answer:
      'If your video upload is stuck in processing for an extended time, we recommend saving the video as a draft and trying the upload again later. This helps to prevent errors and allows you to reattempt the upload under better network conditions.',
  },
  {
    question:
      'Do I have to wait until transcoding is in progress while uploading the video?',
    answer:
      "No, you do not have to wait. Once you select a video, enter all required details, and select a thumbnail for your content, you can click on the 'Save Draft' option while transcoding is in progress. You can then exit or upload a new video. The video will be saved as a draft. Once transcoding is finished, the video status will be 'Ready to Publish'. You can visit the draft later and publish your content.",
  },
  {
    question:
      'I uploaded a video, but it ended up in drafts instead of being published. How can I retrieve it?',
    answer: (
      <p>
        If your video ended up in drafts instead of being published, follow
        these steps to retrieve and publish it:{' '}
        <ol className="list-decimal pl-6">
          <li>Open the LYKSTAGE website and go to your profile.</li>
          <li>Navigate to "My Channel" in the side menu bar.</li>
          <li>
            Look for the "Drafts" section where your saved videos are stored.
          </li>
          <li>Select the video you want to upload from the drafts.</li>
          <li>Review and make any necessary edits.</li>
          <li>Tap/Click on the "Publish" button to post the video.</li>
          If you continue to face issues, please contact our support team for
          assistance.
        </ol>
      </p>
    ),
  },
  {
    question: 'How do business accounts earn on LYKSTAGE?',
    answer:
      'Business accounts on LYKSTAGE earn through ad impressions and watch time, similar to individual creators. For media and broadcasting creators classified as business users, monetization begins for videos as short as 30 seconds, instead of the standard 3-minute requirement for other creators. ',
  },
  {
    question: 'Do business account creators earn rewards as a viewer?',
    answer:
      'No, business account creators do not earn rewards for watching videos as viewers.',
  },
  {
    question: 'Who gets what from the ad revenue?',
    answer: (
      <p>
        On LYKSTAGE, the breakdown of ad revenue is as follows:{' '}
        <ol className="list-decimal pl-6">
          <li>
            <b>Creators:</b> On LYKSTAGE, Creators earn based on ad earnings
            generated by their content traction when ads are served.
          </li>{' '}
          <li>
            <b>Viewers:</b> Viewers earn LYK Coins by watching monetized videos,
            with earnings based on ad revenue from every 30 seconds of watch
            time.
          </li>{' '}
          <li>
            <b>Platform:</b> LYKSTAGE retains a portion of the ad revenue to
            cover operational costs and platform maintenance.
          </li>
        </ol>
        This revenue sharing model ensures that both creators and the viewer
        benefit from their watch time consumption and monetization when ad is
        served. Moreover, earnings on LYKSTAGE are calculated based on watch
        time and ad revenue generated by the video content.
      </p>
    ),
  },
  {
    question:
      'How can I ensure I earn money while watching videos on LYKSTAGE?',
    answer:
      'To earn on LYKSTAGE, you must watch the video uninterrupted while logged in to your LYKSTAGE account. Skipping, fast forwarding, or repeating the video will disqualify you from earning. Additionally, a video is only eligible for earning when ads are displayed.',
  },
  {
    question:
      'Do I have to wait until transcoding is in progress while uploading the video?',
    answer:
      "No, you do not have to wait. Once you select a video, enter all required details, and select a thumbnail for your content, you can click on the 'Save Draft' option while transcoding is in progress. You can then exit or upload a new video. The video will be saved as a draft. Once transcoding is finished, the video status will be 'Ready to Publish'. You can visit the draft later and publish your content.",
  },
  {
    question: 'What are the supported LYKSTAGE file formats?',
    answer:
      "If you encounter an 'invalid file format' error during upload, verify that your file is in one of these formats: mp4, mov, flv, 3gp, avi, mpg, ogg, webm, mkv, or H.264.",
  },
  {
    question: 'How do business accounts earn on LYKSTAGE?',
    answer:
      'Business accounts on LYKSTAGE earn through ad impressions and watch time, similar to individual creators. For media and broadcasting creators classified as business users, monetization begins for videos as short as 30 seconds, instead of the standard 3-minute requirement for other creators.',
  },
  {
    question: 'Do business account creators earn rewards as a viewer?',
    answer:
      'No, business account creators do not earn rewards for watching videos as viewers.',
  },
  {
    question:
      'How can I ensure I earn money while watching videos on LYKSTAGE?',
    answer:
      'To earn on LYKSTAGE, you must watch the video uninterrupted while logged in to your LYKSTAGE account. Skipping, fast forwarding, or repeating the video will disqualify you from earning. Additionally, a video is only eligible for earning when ads are displayed.',
  },
  {
    question:
      'What happens if I am logged in from multiple devices or apps and view content simultaneously?',
    answer:
      'You can be logged in from different devices or apps, but watch time will be counted as unique watch time. This means that while you can access your account from multiple devices, the watch time consumption will be calculated from only one device, as your user ID is identified as a single entity.',
  },
  {
    question:
      'Can I log in with an email and password if I signed up with Google/Apple?',
    answer:
      'No, if you signed up using Google or Apple, please log in using the respective account.',
  },
  {
    question: 'Is this platform available in multiple countries?',
    answer:
      'Yes, LYKSTAGE is currently available in India, the United States, the United Kingdom, Canada, and the United Arab Emirates, with plans for future expansion to additional countries globally.',
  },
  {
    question: 'Can I share videos from other platforms?',
    answer: (
      <p>
        Yes, you can share videos from other platforms as long as they comply
        with our{' '}
        <Link href="/community" color={'blue'} textDecoration={'underline'}>
          community guidelines
        </Link>
        . This allows you to repurpose content you’ve already uploaded
        elsewhere, maximizing your reach and earnings on our platform.
      </p>
    ),
  },
  {
    question: 'My Account Has Been Hijacked/Hacked. How Can I Recover It?',
    answer:
      'If your account has been hijacked or hacked, please email us at support@lykstage.com with details of the issue. Our team will assist you further.',
  },
  {
    question: 'How Can I Keep My LYKSTAGE Account Safe from Suspicious Emails?',
    answer: (
      <p>
        To protect your LYKSTAGE account from phishing and suspicious emails,
        only trust emails coming from official LYKSTAGE domains - lykstages.com,
        lykstag.com, likestg.com, lykstage.me, lkstg.com.
        <ol className="list-decimal pl-6">
          <li>
            <b>Be cautious with email links:</b> Avoid clicking on links or
            downloading attachments from unknown or unexpected emails. Always
            hover over links to verify their actual destination before clicking.
          </li>{' '}
          <li>
            <b>Strong passwords are essential:</b> Use a unique, strong password
            for your LYKSTAGE account and update it periodically.
          </li>{' '}
          <li>
            <b>Keep your password private:</b> Never share your password with
            anyone, especially unknown contacts or websites.
          </li>
          <li>
            <b>Stay informed:</b> Familiarize yourself with common phishing
            tactics and be aware of emails asking for personal or account
            information.
          </li>
        </ol>
        If you come across a suspicious email related to LYKSTAGE, forward it to
        support@lykstage.com for investigation. Stay vigilant and protect your
        account!
      </p>
    ),
  },
  {
    question: 'Is It Possible to Restore a Deleted Video on LYKSTAGE?',
    answer:
      'No, once a video has been deleted from LYKSTAGE, it cannot be restored. The deletion is permanent and irreversible, meaning that the content will be lost and cannot be recovered.',
  },
  {
    question: 'Is It Possible to Recover a Deleted LYKSTAGE Account?',
    answer: (
      <p>
        Yes, if your LYKSTAGE account has been deleted, you can recover it by
        logging back in within 30 days of deletion. After the 30-day period, the
        account will be permanently deleted, and recovery will no longer be
        possible. In such cases, you will need to{' '}
        <Link href="/auth/signup" color={'blue'} textDecoration={'underline'}>
          sign up
        </Link>{' '}
        again and start from the beginning. For further assistance, feel free to
        contact us at support@lykstage.com.
      </p>
    ),
  },
  {
    question: 'I’m Not Seeing Ads on My LYKSTAGE Videos. What Should I Do?',
    answer: (
      <p>
        To see ads on your LYKSTAGE videos, ensure that:
        <ol className="list-decimal pl-6">
          <li>
            Your video meets the
            <b> minimum requirement of at least 3 minutes in length</b>.
          </li>{' '}
          <li>
            Your content follows all
            <b> community and platform guidelines</b>.
          </li>{' '}
          <li>
            Your video has enough traction — ads are more likely to be served
            based on factors such as
            <b>video engagement, watch time, and audience demographics</b>.
          </li>{' '}
        </ol>
        While your videos may meet all monetization criteria, certain external
        factors beyond LYKSTAGE's control can influence the overall outcome.
      </p>
    ),
  },
  {
    question: "What does 'Upload Verified' mean?",
    answer: (
      <p>
        <span >"Upload Verified" is a badge of trust that confirms you&rsquo;ve met the essential criteria to be recognized as an active and genuine creator on LYKSTAGE.
        </span>
        <br />
        <br />
        <span >While meeting all the outlined criteria is necessary, the final decision to grant the "Upload Verified" status rests solely with the LYKSTAGE team. The company reserves the right to approve or deny the badge at its discretion.</span>
        <br />
        <br />
        <h3><strong>How can you become Upload Verified?</strong></h3>
        <br />

        <ul className="list-disc ml-4">
          <li ><strong>Identity Verification</strong><span >: Users must submit a valid government ID only after reaching the threshold limit for redeeming LYK coins, and their channel name must match their LYKSTAGE profile.&nbsp; Additionally, </span><em><span >Upload Verified</span></em><span > status is invitation-based and is granted once users meet the necessary criteria.&nbsp;</span></li>
          <li ><strong>Content Contribution</strong><span >: Creators must have uploaded at least 5 videos, generating a minimum of 250 watch-time units (2 hours of watch time), with no content violations or strikes.</span></li>
          <li ><strong>Engagement Milestones</strong><span >: Creators must have 100 followers or 200 likes across videos, and show consistency by uploading at least 1 video per week for two consecutive weeks (1 video per week).</span></li>
          <li ><strong>LYK Coin Requirement</strong><span >: Users must have enough LYK Coins to meet the redemption threshold for their region.</span></li>
          <li ><strong>Discretionary Consideration</strong><span >: The LYKSTAGE team can grant the status based on potential, referrals, or exceptions for businesses or niche or rising influencers with significant contributions.</span></li>
        </ul>
        <br />

        <strong>"Upload Verified" status</strong><span > is invitation-based and granted at LYKSTAGE&rsquo;s discretion, provided the user meets the outlined criteria. The company reserves the right to approve or deny the badge at its discretion.</span></p>
    )
  },
  {
    question: "What does 'Overall Verified' mean?",
    answer: (
      <p>
        <p>&ldquo;Overall Verified&rdquo; is an advanced verification status that highlights creators or businesses as highly trusted and impactful on LYKSTAGE.</p>
        <br />
        <h3><strong>How can you become Overall Verified?</strong></h3>
        <br />
        <p><strong>Stricter Identity and Bank Verification</strong>:</p>
        <br />
        <ul className="list-disc ml-4">
          <li>Creators must complete ID and bank verification after reaching the threshold limit for redeeming LYK coins for credential verification, payouts, and tax compliance.</li>
          <li>Businesses need to submit company registration documents for verification.</li>
        </ul>
        <p>ID verification requirements vary based on the official documents mandated in each country.</p>
        <br />
        <p><strong>High-Performance Content Contribution</strong>:</p>
        <br />
        <ul className="list-disc ml-4">
          <li>Users need to upload 15 videos with at least 1,000 cumulative watch-time units (8 hours of watch time).</li>
          <li>A 5% engagement rate is required across all videos (likes, comments, shares).</li>
        </ul>
        <br />
        <p><strong>Reputation and Activity</strong>:</p>
        <br />
        <ul className="list-disc ml-4">
          <li>A minimum of 500 followers or 1,000 likes across all content.</li>
          <li>Users must show consistent activity on LYKSTAGE for at least 60 days, with weekly uploads.</li>
        </ul>
        <br />
        <p><strong>Strict Platform Compliance</strong>:</p>
        <br />
        <ul className="list-disc ml-4">
          <li>Users should not have any strikes, suspensions, or content violations in the past 90 days.</li>
          <li>Users must avoid uploading copyrighted content.</li>
        </ul>
        <br />
        <p><strong>Discretionary Verification for Established Users</strong>:</p>
        <br />
        <p>The LYKSTAGE team may grant verification status based on discretionary consideration as well. These include:</p>
        <br />
        <ul className="list-disc ml-4">
          <li>Recognized media houses, organizations, or brands with significant reputations.</li>
          <li>Celebrities or influencers with a significant following on other platforms.</li>
          <li>Verified users from platforms like YouTube or Instagram, with proof of content performance.</li>
          <li>Highly active LYKSTAGE users who achieve exceptional engagement and contribute substantially to the platform.</li>
        </ul>
      </p>
    )
  },
  {
    question: "What is the Review and Upgrade Process for verification statuses on LYKSTAGE?",
    answer: (
      <p>
        <p>The Review and Upgrade Process for verification statuses on LYKSTAGE is as follows:</p><br/>
        <ol className="list-decimal pl-6">
          <li><strong>Verification Status Eligibility:</strong><em>Upload Verified</em> and <em>Overall Verified</em> statuses are granted solely at LYKSTAGE's discretion through an invitation-only process.</li>
          <li><strong>Reviews</strong>: The LYKSTAGE team carefully reviews users to ensure they meet verification criteria.</li>
          <li><strong>Verification Upgrades</strong>: Upgrades to higher verification levels are decided by the LYKSTAGE review team at their discretion.</li>
          <li><strong>Invitation-Only Process:</strong> Invitations are extended to users who meet the platform's standards after a fair review process.</li>
        </ol>
        <br/>
        <p>This process ensures fairness, transparency, and opportunities for users to meet verification criteria</p>
      </p>

    )
  },
  {
    question: "What do the tiers include?",
    answer: (
      <p className="pl-6">
        <ul className="list-disc">
          <li><strong>Free: </strong>10 GB storage, earnings from ads.</li>
          <li className='mt-1'><strong>Plus: </strong>100 GB, ads plus pay-per-view and password protection for verified creators, ₹199 a month or ₹1,199 a year including GST in India.</li>
          <li className='mt-1'><strong>Pro: </strong>2 TB, the same features, ₹499 a month or ₹2,999 a year including GST.</li>
        </ul>
        <p className='mt-2'>
          Prices in other markets are shown in your local checkout.
        </p>
      </p>

    )
  },
  {
    question: "What are the storage limits for each plan?",
    answer: (
      <p>
        <ul className="list-disc pl-6">
          <li><strong>Free: </strong>10 GB</li>
          <li><strong>Plus: </strong>100 GB</li>
          <li><strong>Pro: </strong>2 TB</li>
        </ul>
      </p>

    )
  },
  {
    question: "Can I upgrade or downgrade my plan anytime?",
    answer: (
      <p>
        <p>Yes. You can change your plan anytime from your account settings.</p>
        <ul className="list-disc pl-6">
          <li><strong>Upgrades </strong>take effect immediately</li>
          <li><strong>Downgrades </strong>apply after your current billing period ends</li>
          <li>You won’t lose your content, but access to paid features will be removed if you downgrade</li>
        </ul>
      </p>

    )
  },
  {
    question: "Will my subscription auto-renew?",
    answer: (
      <p>
        Yes. All paid plans renew automatically each month or year (based on your choice).
      </p>
    )
  },
  {
    question: "What happens to my earnings if I cancel or downgrade?",
    answer: (
      <p>
        <p>You keep all your past earnings.</p><br/>
        <p>On the Free plan, you’ll still earn from ads, but <strong>PPV monetization and any password-protected content under PPV will be paused.</strong> </p><br/>
        <p>You can reactivate them anytime by resubscribing to a paid plan.</p>
      </p>
    )
  },
  {
    question: "Are the paid plans refundable?",
    answer: (
      <p>
        No. Subscriptions are non-refundable. You’ll continue to enjoy the benefits until your billing cycle ends.
      </p>
    )
  },
  {
    question: "Is there a free trial for Plus or Pro?",
    answer: (
      <p>
        Currently, there’s no free trial. But you can start with the Free plan to explore core features and upgrade when ready.
      </p>
    )
  },
  {
    question: "What payment methods are accepted?",
    answer: (
      <p>
        <ul className="list-disc pl-6">
          <li><strong>India: </strong>Currently, only <strong>credit and debit cards</strong> are accepted.</li>
          <li><strong>Other countries: </strong>Credit/debit cards via Stripe.</li>
        </ul>
      </p>

    )
  },
  {
    question: "Why are prices different in India and the US?",
    answer: (
      <p>
        Prices are adjusted based on region and currency value to stay affordable and fair for all users globally.
      </p>
    )
  },
  {
    question: "Will I be charged in my local currency?",
    answer: (
      <p>
        <p>Yes.</p>
        <ul className="list-disc pl-6">
          <li><strong>Indian users: </strong>INR</li>
          <li><strong>Others: </strong>USD <br></br>The price shown at checkout includes applicable taxes.</li>
        </ul>
      </p>

    )
  },
  {
    question: "Can I subscribe while traveling abroad?",
    answer: (
      <p>
        Yes. Your billing remains tied to the country you selected during account registration, no matter where you are.
      </p>
    )
  },
  {
    question: "Is there a limit to PPV or password-protected uploads?",
    answer: (
      <p>
        No set limit. As long as you're within your plan’s storage quota, you can upload as many premium or protected videos as you'd like.
      </p>
    )
  },
  {
    question: "How to change payment method?",
    answer: (
      <p>
        You can update your card details during the checkout process while making a new payment.
      </p>
    )
  },
  {
    question: " What happens if my card expires or payment fails repeatedly?",
    answer: (
      <p>
        We’ll notify you via email and retry the payment a few times. If it still fails, your subscription will be <strong>cancelled</strong> due to non-payment. You can resubscribe anytime once the issue is resolved.
      </p>
    )
  },
  {
    question: "Is this a one-time payment or recurring?",
    answer: (
      <p>
        It’s a recurring subscription that is billed monthly or yearly based on your chosen plan. You can cancel anytime, and your subscription will remain active until the end of the current billing cycle.
      </p>
    )
  },
  {
    question: "Is my data secure during payment?",
    answer: (
      <p>
        Yes. We use industry-standard encryption and secure payment gateways. Your payment information is never stored on our servers.
      </p>
    )
  },
  {
    question: " Can I change or cancel my subscription plan?",
    answer: (
      <p>
        Upgrades take effect immediately with a prorated charge. Downgrades and cancellations take effect at the end of your current billing period; you keep your plan until then. There are no refunds for unused time.
      </p>
    )
  },
  {
    question: "How do I sign in on my TV?",
    answer: (
      <>
        <p>
          Open LYKSTAGE on your TV; it shows an activation code. On your phone, open the LYKSTAGE app, tap Menu, then Activate TV, enter the code and tap Activate. The TV connects automatically.
        </p>
        <p><strong>The code expired before I could enter it.</strong></p>
        <p>Codes refresh every five minutes. Enter the new code shown on the TV.</p>
      </>
    )
  },
  {
    question: "Does LYKSTAGE distribute my videos on Connected TV platforms?",
    answer: (
      <p>
        Yes. If you enable Connected TV distribution, your video may be published on eligible third-party Connected TV platforms where LYKSTAGE is available.
      </p>
    )
  },
  {
    question: "Will my earnings be the same on Connected TV as on mobile and web?",
    answer: (
      <p>
        Earnings from Connected TV may vary because some third-party platforms operate under revenue-sharing arrangements that differ from mobile, tablet, or web distribution.
      </p>
    )
  },
  {
    question: "Why are earnings different on Connected TV?",
    answer: (
      <p>
        Some Connected TV partners may take a portion of the advertising revenue generated from your video. As a result, your earnings from Connected TV views may be lower or different compared to other LYKSTAGE platforms.
      </p>
    )
  },
  {
    question: "Do I need to give consent for Connected TV distribution?",
    answer: (
      <p>
        Yes. When you choose to enable Connected TV distribution during upload, you must confirm that you understand and agree that earnings may vary due to partner revenue-sharing arrangements.
      </p>
    )
  },
  {
    question: 'When can I complete ID verification?',
    answer: (
      <p>You can complete ID verification between the <b>1st and 6th of every month</b>, provided your wallet meets the required threshold.</p>
    ),
  },
  {
    question: "Why can’t I redeem my latest earnings?",
    answer: (
      <p>Earnings from the current month are included in the next statement cycle. You can redeem them in the <b>following month's redemption window.</b></p>
    ),
  },
  {
    question: 'What happens if I miss the verification window?',
    answer: (
      <p>You will need to wait until the <b>next month (1st–6th)</b> to complete your ID verification.</p>
    ),
  },
  {
    question: 'What happens if I miss the redemption window?',
    answer: (
      <p>Your balance will remain in your wallet and can be redeemed in the <b>next redemption window (7th–14th).</b></p>
    ),
  },
  {
    question: 'Why are there fixed windows?',
    answer: (
      <p>Fixed windows help ensure secure processing, compliance checks, and accurate statement-based payouts.</p>
    ),
  },
  {
    question: 'Can I verify and redeem anytime?',
    answer: (
      <p>No. ID verification and redemption are only available during their respective monthly windows.</p>
    ),
  },
  {
    question: 'Which countries have earnings active?',
    answer: (
      <>
        <p>
          LYKSTAGE is currently live with earnings enabled for users in the US, UK, Canada, UAE, and India. Both creators (for the content they publish) and eligible logged-in viewers (through our watch-time rewards program) participate in earnings in these markets.
        </p>
        <p>
          Redemption thresholds and requirements vary by country — for example:
          <ul className="list-disc pl-8">
            <li>US: 1,300 LYK coins ($26)</li>
            <li>India: 130 LYK coins ($2.60)</li>
          </ul>
        </p>
        <p>
          To redeem your wallet, you’ll need to complete ID verification and link/verify your bank account.
        </p>
      </>
    ),
  },
  {
    question: 'How much money will I get for views on my video?',
    answer: (
      <>
        <p>
          LYKSTAGE does not pay only based on the number of views. Your earnings depend on <b>monetized watch time</b> — meaning how much time viewers spend watching your content and whether ads shown during that viewing are fully watched and not skipped. The more genuine watch time your content generates, the better your earning potential.
        </p>
        <p>
          LYKSTAGE runs on a patent-approved Watch-Time Monetization Model, built to create a more balanced value exchange than traditional view-based payouts.
          <ul className="list-disc pl-4">
            <li>Creators earn 45%–70% of revenue when watch-time on their content becomes monetized — from the very first view, with no subscriber minimums and no waiting periods.</li>
            <li>Monetization is triggered when content is watched uninterrupted and the ad served during viewing is watched in full. At that point, the creator earns first, the eligible logged-in viewer can be rewarded, and the platform earns — all backed by real ad revenue, with no subsidy-led model.</li>
            <li>Earnings are credited as LYK coins (1 LYK coin = $0.02) and your creator dashboard shows your balance in real-time.</li>
          </ul>
        </p>
      </>
    ),
  },
  {
    question: 'Which devices is LYKSTAGE on?',
    answer: (
      <>
        <p>
          LYKSTAGE is a true cross-screen platform — publish once, reach audiences across every screen:
          <ul className="list-disc pl-8">
            <li>
              Smart TVs:
               <a className='text-blue-600 underline' rel="noopener noreferrer">Samsung TV</a> ,
               <a href="https://us.lgappstv.com/main/tvapp/detail?appId=1278296&catCode1=&moreYn=N&cateYn=N&orderType=0&headerName=%EC%A0%84%EC%B2%B4&appRankCode=&sellrUsrNo=&curPage=1" target="_blank" className='text-blue-600 underline' rel="noopener noreferrer">LG TV</a> , 
               <a href="https://channelstore.roku.com/en-gb/details/42360390a176ea5a65d52d0fbc3e4fa7:38d9d1fca78b37f292f3d1064e7135a8/lykstage" target="_blank" className='text-blue-600 underline' rel="noopener noreferrer">Roku TV</a> , 
               <a href="https://apps.apple.com/in/app/lykstage/id6754064834" target="_blank" className='text-blue-600 underline' rel="noopener noreferrer">Apple TV</a> , 
               <a href="https://play.google.com/store/apps/details?id=com.lykstage.app&hl=en_IN" target="_blank" className='text-blue-600 underline' rel="noopener noreferrer">Android TV / Google TV</a> , 
               <a href="https://www.amazon.com/dp/B0FBX67MHC" target="_blank" className='text-blue-600 underline' rel="noopener noreferrer">Amazon Fire TV</a>
            </li>
            <li>
              Mobile apps:
               <a href="https://apps.apple.com/us/app/lykstage-plus/id6754064834" target="_blank" className='text-blue-600 underline' rel="noopener noreferrer">iOS (App Store)</a>
                &nbsp; and &nbsp; 
               <a href="https://play.google.com/store/apps/details?id=com.lykstage.app" target="_blank" className='text-blue-600 underline' rel="noopener noreferrer">Android (Google Play)</a>
            </li>
            <li>Desktop Web: <a href="https://lykstage.com" target="_blank" className='text-blue-600 underline' rel="noopener noreferrer">lykstage.com</a></li>
            <li>Mobile Web: <a href="https://m.lykstage.com" target="_blank" className='text-blue-600 underline' rel="noopener noreferrer">m.lykstage.com</a></li>
          </ul>
        </p>     
        <p>
          All access points are connected to a single account — your watch-time, earnings, channel, and content sync across every device.
        </p>
      </>
    ),
  },
  {
    question: 'What kind of content will I see?',
    answer: (    
      <p>
        LYKSTAGE is language and geo-agnostic — we host content across 30+ categories (entertainment, music, comedy, news, lifestyle, education, gaming, sports, devotional, business, technology, kids’ content, regional cinema, short-form, and more) in around 60 languages. This makes LYKSTAGE a particularly strong additional distribution platform for creators and media companies looking to share their voice, expand reach, and build audience value across multicultural and multilingual segments that mainstream platforms underserve.
      </p>
    ),
  },
  {
    question: 'Can I use a VPN or proxy to watch LYKSTAGE content?',
    answer: (  
    <>
      <p>
        No. Using a VPN, proxy, or any tool to misrepresent your location is a violation of LYKSTAGE’s Terms of Service. LYKSTAGE
        detects VPN and proxy use as part of our fraud-prevention checks.
      </p>
      <p>
        Watch time accumulated while masking your real location may be excluded from your earnings, and your account may be flagged
        for review or suspended. LYKSTAGE is currently live in India, the US, UK, Canada, and the UAE — please use the platform from
        your actual location in one of these countries.
      </p>
    </>  
    ),
  },
  {
    question: 'Can I have multiple LYKSTAGE accounts under my name?',
    answer: (  
    <>
      <p>
        No. LYKSTAGE allows only one account per person.
      </p>
      <p>
        The platform identifies users primarily by financial and government-issued identity — Aadhaar, PAN, and bank account — rather
        than only by phone number or email ID. If two accounts share the same Aadhaar, PAN, or bank account, the system treats them as
        the same person, regardless of whether different phone numbers or emails were used during signup.
      </p>
      <p>
        Operating multiple accounts under the same financial identity may result in suspension of the accounts and invalidation of any
        accumulated coins under our Terms of Service.
      </p>
    </>  
    ),
  },
  {
    question: 'Can I watch my own channel videos to earn LYK Coins?',
    answer: (  
    <>
      <p>
        No. Creators watching their own content — whether from their primary account or any secondary account — to generate views,
        watch time, or LYK Coin earnings is a violation of LYKSTAGE policy.
      </p>
      <p>
        This applies regardless of which device is used: mobile, laptop, tablet, or Connected TV. The platform actively detects and excludes
        such activity from earnings calculations on both the creator side and the viewer side. LYKSTAGE earnings are designed to reward
        genuine audience engagement, not self-viewing.
      </p>
    </>  
    ),
  },
  {
    question: 'How does LYKSTAGE detect manipulation of the rewards system?',
    answer: (  
    <>
      <p>
        LYKSTAGE applies a multi-layer integrity framework that includes:
        <ul className="list-disc pl-8">
            <li>
              VPN and proxy detection at IP level
            </li>
            <li>
              Cross-account deduplication via Aadhaar, PAN, and bank account
            </li>
            <li>
              Device fingerprinting and multi-account-per-device detection
            </li>
            <li>
              Self-view detection at the creator-content-viewer level
            </li>
            <li>
              Watch-time deduplication per user, ad, and content per 24-hour window
            </li>
            <li>
              Ad frequency capping enforced before delivery
            </li>
            <li>
              Geo-location mismatch detection between declared country and active IP
            </li>
            <li>
              Behavioural anomaly detection for automation and bot activity
            </li>
        </ul>
      </p>
      <p>
        These controls operate continuously in the background. Genuine users are never affected. Activity that fails one or more of these
        checks may be flagged, excluded from earnings, or escalated for review.
      </p>
    </>  
    ),
  },
  {
    question: 'Why am I seeing the same ads repeatedly on LYKSTAGE?',
    answer: (  
    <>
      <p>
        Every advertiser sets a frequency cap on their campaigns — the maximum number of times their ad is shown to the same user
        within a defined period. Frequency capping is a standard industry practice that protects viewers from ad fatigue and ensures fair
        distribution of ad inventory across users.
      </p>
      <p>
        Once you reach the cap for a specific ad, you will not see it again until the cap window resets — regardless of how many videos you watch.
      </p>
    </>  
    ),
  },
  {
    question: 'Do I earn LYK Coins from every ad I see?',
    answer: (  
    <>
      <p>
        You earn LYK Coins from ads only when all of the following conditions are met:
        <ul className="list-disc pl-8">
            <li>
              The ad is watched to completion (100% of the ad duration).
            </li>
            <li>
              The same ad on the same video has not already been watched in the last 24 hours.
            </li>
            <li>
              The ad has not reached its frequency cap for you.
            </li>
            <li>
              You are logged in to a fully onboarded account.
            </li>
            <li>
              The watch time accumulated before the ad was earned through engaged, uninterrupted viewing.
            </li>
        </ul>
      </p>
      <p>
        If any of these conditions are not met, the watch time during that segment is not monetized for you, the creator, or the platform.
      </p>
    </>  
    ),
  },
  {
    question: 'What happens if I skip an ad?',
    answer: (  
    <>
      <p>
        Skipping an ad forfeits the monetization of the watch time accumulated between the previous ad and the skipped ad.
      </p>
      <p>
        For example, if you watched 5 minutes of content and then skipped the next ad, those 5 minutes do not convert to LYK Coins — for
        you, for the creator, or for the platform. To earn from your viewing time, you must let the ad play to completion.
      </p>
    </>  
    ),
  },
  {
    question: 'Can I predict which videos will have ads served on them?',
    answer: (  
    <>
      <p>
        No. LYKSTAGE’s ad serving algorithm decides dynamically when to serve ads based on factors including content traction,
        frequency caps already reached, advertiser campaign targeting, and ad inventory availability at that moment.
      </p>
      <p>
        You cannot predict which content will deliver an ad. This unpredictability is by design — it helps protect the platform from being
        gamed and ensures that ads are served based on genuine value to advertisers, not based on viewer strategy.
      </p>
    </>  
    ),
  },
  {
    question: 'Does pausing, tab-switching, or backgrounding the app affect my earnings?',
    answer: (  
    <>
      <p>
        Yes. LYKSTAGE only awards watch time for actively engaged, uninterrupted viewing. Watch time accumulation halts when you
        pause, switch tabs, background the app, turn off the screen, or fast-forward.
      </p>
      <p>
        When you resume viewing, the 30-second timer for the next Watch Time Unit restarts — partial accumulation does not carry over
        across interruptions.
      </p>
    </>  
    ),
  },
  {
    question: 'Can multiple family members use LYKSTAGE on the same TV?',
    answer: (  
    <>
      <p>
        Yes. Connected TV devices — including Smart TVs, Roku, Apple TV, Android TV, Samsung TV, LG TV, and Fire TV — are
        recognised as household devices.
      </p>
      <p>
        Different family members can each have their own LYKSTAGE account and use the same TV. Each account watches and earns
        independently, provided each account is linked to a unique person with their own Aadhaar, PAN, and bank account.
      </p>
    </>  
    ),
  },
  {
    question: 'Can I have multiple accounts on the same mobile phone or laptop?',
    answer: (  
    <>
      <p>
        Multiple accounts on the same mobile phone, laptop, or desktop device is treated as a fraud signal and may be flagged for review.
        Mobile phones and laptops are personal devices — multiple accounts on a single such device is not consistent with genuine use.
      </p>
      <p>
        If the system detects this pattern, the accounts may be subject to additional verification at the time of redemption or may be
        suspended if fraud is confirmed.
      </p>
    </>  
    ),
  },
  {
    question: 'Does the TV household exception allow me to use multiple accounts of my own on the same TV?',
    answer: (  
    <>
      <p>
        No. The Connected TV exception is designed for genuinely different people in a household — family members, partners,
        roommates — each with their own LYKSTAGE account.
      </p>
      <p>
        It is not a loophole that allows a single person to operate multiple accounts on the same TV. If multiple accounts on the same TV
        share the same Aadhaar, PAN, or bank account, the system treats them as the same person and the exception does not apply.
      </p>
    </>  
    ),
  },
  {
    question: 'Can I have both a personal account and a business account on LYKSTAGE?',
    answer: (  
    <>
      <p>
        A single person can operate one Individual account AND one Business account, provided the Business account represents a
        registered legal entity (a company, media organisation, or business).
      </p>
      <p>
        The Business account must use the legal entity’s KYC documents — company registration, business PAN, business bank account
        — not the owner’s personal Aadhaar, PAN, and bank details. You cannot operate two Individual accounts under the same personal
        identity.
      </p>
    </>  
    ),
  },
  {
    question: 'Will I be able to create multiple channels under one LYKSTAGE account in the future?',
    answer: (  
    <>
      <p>
        Yes. We are working on a feature that will allow a single LYKSTAGE account (parent account) to create and manage multiple
        channels — for example, one channel for comedy, another for cooking, another for music.
      </p>
      <p>
        <b>This feature has not launched yet.</b> When it does, you will be able to:
        <ul className="list-disc pl-8">
            <li>
              Create multiple channels under your single LYKSTAGE account.
            </li>
            <li>
              Upload distinct content to each channel.
            </li>
            <li>
              Manage each channel independently from a single account dashboard.
            </li>
        </ul>
      </p>
      <p>
        Importantly, multi-channel is a feature for <b>content organisation</b>, not for earnings multiplication. All channels under one parent
        account share the same KYC identity (Aadhaar, PAN, bank account), and all platform integrity controls continue to apply at the
        parent account level (see the next FAQ for details).
      </p>
    </>  
    ),
  },
  {
    question: 'What is the difference between multiple accounts and multiple channels under one account?',
    answer: (  
    <>
      <p>
        These are fundamentally different and treated very differently by LYKSTAGE:
      </p>
      <p>
        <b>Multiple accounts</b> means one person creating two or more separate LYKSTAGE accounts. This is a Terms of Service violation
        and is detected via KYC deduplication (same Aadhaar, PAN, or bank account = same person). Multiple accounts may result in
        suspension and invalidation of coins.
      </p>
      <p>
        <b>Multiple channels under one account</b> (upcoming feature) means one person operating a single LYKSTAGE account that hosts
        several different channels for different types of content. This is legitimate and will be supported by LYKSTAGE when launched.
      </p>
      <p>
        The key difference: multiple accounts attempts to create multiple identities (which is fraudulent), while multiple channels lets one
        identity manage diverse content (which is creator freedom).
      </p>
    </>  
    ),
  },
  {
    question: 'When the multi-channel feature launches, will I earn more from watching my own content?',
    answer: (  
    <>
      <p>
        No. The multi-channel feature is for content organisation only — not for unlocking additional earning opportunities through your own
        viewing.
      </p>
      <p>
        Here is how platform integrity controls continue to apply across all your channels:
        <ul className="list-disc pl-8">
            <li>
              <b>One viewer identity per account:</b> As a viewer, you have one identity — your parent account — no matter how many channels
              you create as a creator.
            </li>
            <li>
              <b>Ad frequency caps apply at the parent account level:</b> If you have already seen an ad to its frequency limit, watching content
              on any of your own channels will not let you earn from that ad again.
            </li>
            <li>
              <b>Self-view detection works across all your channels:</b> Watching content on your own channels — single or multiple — does not
              generate viewer earnings.
            </li>
            <li>
              <b>Watch-time deduplication continues to apply:</b> Watching the same ad on the same content within 24 hours generates earnings
              only on the first watch.
            </li>
        </ul>
      </p>
      <p>
        In short, multi-channel lets you organise different types of content cleanly, but it does not unlock additional viewer earnings on your
        own content.
      </p>
    </>  
    ),
  },
  {
    question: 'Which countries can I sign up for LYKSTAGE from?',
    answer: (  
    <>
      <p>
        LYKSTAGE is currently live for new signups in India, the United States, the United Kingdom, Canada, and the United Arab
        Emirates.
      </p>
      <p>
        If you attempt to sign up from a country outside this list, the platform will display “Sign-up unavailable in your region” and prevent
        account creation. We are actively working on expanding to additional countries — please wait for LYKSTAGE to launch in your
        region rather than using a VPN to circumvent regional restrictions.
      </p>
    </>  
    ),
  },
  {
    question: 'My registered country is India but my phone number has a different country code (e.g., +1). Is this a problem?',
    answer: (  
    <>
      <p>
        No. LYKSTAGE recognises that many users legitimately have phone numbers from countries different from their country of
        residence. NRIs, expats, international students, business travellers, and dual residents commonly have a phone number from one
        country and reside in another.
      </p>
      <p>
        Your declared country at signup governs your account’s region, not your phone’s country code. As long as you are using
        LYKSTAGE genuinely from your declared country, the phone country code difference is not a problem for your account or earnings.
      </p>
    </>  
    ),
  },
  {
    question: 'I am travelling outside my supported country. Will my earnings continue?',
    answer: (  
    <>
      <p>
        Watch time and earnings are tied to your declared country at signup, not your current location. If you signed up in a supported
        country (India, US, UK, Canada, or UAE), you will continue to earn even when travelling internationally.
      </p>
      <p>
        However, if your IP location consistently does not match your declared country over an extended period, the system may flag your
        activity for fraud review.
      </p>
    </>  
    ),
  },
  {
    question: 'I signed up earlier and my country shows as something outside the 5 supported countries. What should I do?',
    answer: (  
    <>
      <p>
        If you signed up earlier under our previous broader country support and your registered country is now outside our 5 supported
        markets, you will be prompted to select a supported country on your next web login — from India, US, UK, Canada, or UAE.
      </p>
      <p>
        This is a one-time correction. Once you select a supported country, the field is locked and further changes require contacting our
        support team. Your existing coins and account history are preserved through this correction.
      </p>
    </>  
    ),
  },
  {
    question: 'Why are my LYK Coins not increasing even though I am watching different videos?',
    answer: (  
    <>
      <p>
        There are several legitimate reasons why your coin balance may not increase as quickly as you expect:
        <ul className="list-disc pl-8">
            <li>
              <b>Frequency caps reached:</b> If you have already seen the available ads to their frequency limits, additional viewing of the same
              ads will not earn coins.
            </li>
            <li>
              <b>Daily deduplication:</b> Watching the same ad on the same video multiple times within 24 hours only generates coins on the first
              watch.
            </li>
            <li>
              <b>Self-view detection:</b> Watching your own channel’s content does not generate viewer earnings. When the multi-channel feature
              launches, this rule applies across all your channels under one parent account.
            </li>
            <li>
              <b>Multi-account deduplication:</b> If multiple accounts under the same financial identity are detected, earnings may be consolidated
              or excluded.
            </li>
            <li>
              <b>Geo or VPN mismatch:</b> If your IP location does not match your declared country, watch time may be flagged or excluded.
            </li>
            <li>
              <b>Ads not served:</b> If the content does not meet ad eligibility criteria, no ads are served and no coins are earned from that watching.
            </li>
            <li>
              <b>Display rounding:</b> Earnings smaller than four decimal places display as 0.0000 until they accumulate above the display
              threshold.
            </li>
        </ul>
      </p>
      <p>
        If you have ruled out all of these and still believe your earnings are incorrect, please email{' '}
        <a
          href="mailto:support@lykstage.com"
          className="text-blue-600 underline"
        >
          support@lykstage.com
        </a>
        {' '}with your account details.
      </p>
    </>  
    ),
  },
  {
    question: 'Why might my LYK Coin balance be lower than I expected?',
    answer: (  
    <>
      <p>
        Your visible coin balance reflects only earnings that have passed LYKSTAGE’s integrity checks. Some watch time and impressions
        are excluded from earnings calculations if they:
        <ul className="list-disc pl-8">
            <li>
              Came from non-monetized regions or content
            </li>
            <li>
              Were generated during VPN or proxy use
            </li>
            <li>
              Were flagged as duplicate (same user x same ad x same content within 24 hours)
            </li>
            <li>
              Were from anonymous (non-logged-in) viewing on your devices
            </li>
            <li>
              Were generated through self-viewing of your own channel
            </li>
            <li>
              Were flagged as invalid traffic (bot or automation patterns)
            </li>
        </ul>
      </p>
      <p>
        Your displayed balance is the verified amount available for redemption once you reach the threshold.
      </p>
    </>  
    ),
  },
  {
    question: 'Why might my redemption be delayed or rejected even though I have enough coins?',
    answer: (  
    <>
      <p>
        Redemption requires successful completion of verification and fraud-prevention checks. Common reasons for delay or rejection
        include:
        <ul className="list-disc pl-8">
            <li>
              KYC documents (Aadhaar, PAN, ID) do not match across your profile and bank account.
            </li>
            <li>
              The Aadhaar, PAN, or bank account is already associated with another LYKSTAGE account.
            </li>
            <li>
              Your watch activity shows patterns inconsistent with genuine viewing (VPN use, multi-account activity, self-viewing, automation).
            </li>
            <li>
              Your declared country does not match your sustained IP geo-location.
            </li>
            <li>
              Required verification information is missing or incorrect.
            </li>
        </ul>
      </p>
      <p>
        If your redemption is delayed, ensure your KYC details are accurate and you are using LYKSTAGE genuinely. For specific issues, email{' '}
        <a
          href="mailto:support@lykstage.com"
          className="text-blue-600 underline"
        >
          support@lykstage.com
        </a>
        .
      </p>
    </>  
    ),
  },
  {
    question: 'What identity details must be unique across LYKSTAGE accounts?',
    answer: (  
    <>
      <p>
        At the time of redemption, each LYKSTAGE account must be verified with the following unique details:
        <ul className="list-disc pl-8">
            <li>
              Unique phone number
            </li>
            <li>
              Unique email address
            </li>
            <li>
              Valid KYC / government-issued ID (Aadhaar for India, applicable IDs for other markets)
            </li>
            <li>
              Unique PAN (India) or equivalent tax ID
            </li>
            <li>
              Unique bank or payout account
            </li>
        </ul>
      </p>
      <p>
        If any of these details match another account on the platform, both accounts will be flagged and only one will be eligible for
        redemption.
      </p>
    </>  
    ),
  },
  {
    question: 'Will I be notified if my account is flagged for review?',
    answer: (  
    <>
      <p>
        If your account is flagged for routine fraud review and the review concludes that the activity is genuine, you will not be notified —
        the checks happen automatically in the background and do not interrupt normal use.
      </p>
      <p>
        If a review concludes that policy violations have occurred (such as VPN use, multi-account operation, or self-viewing), you may
        receive an email notification with details of the policy violated and any consequences. In serious cases, the account may be
        suspended pending your response.
      </p>
      <p>
        We encourage all users to follow the Terms of Service and use LYKSTAGE genuinely — the platform is designed to reward
        genuine engagement and all our integrity checks are in place to protect the experience for the entire LYKSTAGE community.
      </p>
    </>  
    ),
  },
  {
    question: 'What does verification cost?',
    answer: (  
    <>
      A one-time verification fee is deducted from your balance: 10 LYK Coins ($0.20) in India, 300 ($6.00) in the US, UK and Canada, and 200 ($4.00) in the UAE. Verification is open from the 1st to the 6th of each month, with three attempts.
    </>  
    ),
  },
  {
    question: 'Is 130 LYK Coins the verification fee?',
    answer: (  
    <>
      <p>
        No. 130 LYK Coins ($2.60) is the <b>minimum wallet balance</b> required to initiate verification and to redeem in India. In other markets, the minimum is 1,300 LYK Coins ($26.00). The verification fee is deducted from your balance at verification.
      </p>
    </>  
    ),
  },
  {
    question: "Why can't I redeem right after verifying?",
    answer: (  
    <>
      <p>
        Because the verification fee is deducted at verification, your balance will drop below the redemption minimum. For example, in India a balance of 130 LYK Coins becomes 120 after the 10-Coin fee; in the US, 1,300 becomes 1,000 after the 300-Coin fee. You'll need to earn back up to the minimum (130 / 1,300) before your first redemption. This happens once — after that, you redeem whenever your balance reaches the minimum.
      </p>
    </>  
    ),
  },
  {
    question: 'When can I redeem, and what is the fee?',
    answer: (  
    <>
      Redemptions are open from the 7th to the 14th of each month. A redemption fee is deducted from each redemption: 5 LYK Coins in India, or 6% of the amount redeemed in the US, UK, Canada and UAE. The fee is shown before you confirm.
    </>  
    ),
  },
  {
    question: 'How much will I actually receive?',
    answer: (  
    <>
      <p>
        <b>India:</b> redeeming at 130 LYK Coins, the 5-Coin redemption fee is deducted and you receive 125 LYK Coins — $2.50.
      </p>
      <p>
        <b>United States, United Kingdom, Canada, and UAE:</b> Redeeming at 1,300 LYK Coins, a 6% redemption fee (78 Coins) is deducted, and you receive 1,222 LYK Coins - equivalent to $24.44
      </p>
      <p>
        The same applies to every redemption. The verification fee is charged only once, at verification — never at redemption.
      </p>
    </>  
    ),
  },
  {
    question: 'When can I verify and redeem?',
    answer: (  
    <>
      <p>
        <b>Verification:</b> the 1st to the 6th of every month, with up to three attempts.
      </p>
      <p>
        <b>Redemption:</b> the 7th to the 14th of every month, based on the balance in your most recently released statement.
      </p>
    </>  
    ),
  },
  {
    question: 'What do I need before I can redeem?',
    answer:
      'Three things: a direct contact email linked to your account (required for everyone, including Apple Sign-in users with a private relay email), completed identity verification, and a balance above the minimum. The minimum is 130 LYK Coins in India and 1,300 LYK Coins in other markets.',
  },
  {
    question: 'How long does a payout take?',
    answer:
      'Once your redemption request is received, funds typically reach your linked payout method within 5 to 7 business days. You will get a receipt by email with the amount, fee and reference.',
  },
  {
    question: 'Why is there a 24-hour hold after I change my contact email?',
    answer:
      'For your security, redemptions are paused for 24 hours after a contact email is added or changed. The Redeem button shows the countdown.',
  },
  {
    question: 'What is a complimentary upgrade?',
    answer:
      'Established creators with 10,000 or more subscribers or an equivalent audience on any platform can apply for a free Plus or Pro plan for 12 months. Applications are reviewed within 3 to 5 business days.',
  },
  {
    question: 'Will I get an invoice?',
    answer:
      'Yes. A tax invoice is emailed after every charge and is available in your billing history. India invoices include GST; you can add a GSTIN if you are a registered business.',
  },
  {
    question: 'I signed up with Apple and hid my email. Does that work?',
    answer:
      'Yes, for watching and uploading. To redeem earnings you must add a direct contact email in Settings; it is used for payout confirmations, statements and account recovery. Your Apple sign-in does not change.',
  },
  {
    question: 'Can I change my date of birth or country?',
    answer:
      'Date of birth is set once at sign-up. Country sets your payout currency and fees and can only be changed through Support.',
  },
  {
    question: 'How long does review take after I upload?',
    answer:
      'Most videos are reviewed within 24 hours. You will be notified when your video is live, or told why it was not approved with an option to request a review.',
  },
  
]


